import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { BsFillPersonLinesFill } from 'react-icons/bs';

const Footer = () => {
  return (
    <footer name='footer' className="bg-[#0a192f] text-white py-4">
      <div className="container mx-auto flex justify-center items-center">
        <ul className="flex space-x-8 pb-8">
          <li>
            <a href="https://github.com/varadk20" target="_blank" rel="noopener noreferrer">
              <FaGithub className="text-2xl" />
            </a>
          </li>
          <li>
            <a href="https://in.linkedin.com/in/varad-khedekar-286181263" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="text-2xl" />
            </a>
          </li>
          <li>
            <a href="mailto:varadpk20@gmail.com">
              <FaEnvelope className="text-2xl" />
            </a>
          </li>
          <li>
            <a href="https://drive.google.com/file/d/1ZqR-wZDiteHErYJRjyHUCGTAzyTKR9nY/view?usp=sharing" target="_blank" rel="noopener noreferrer">
              <BsFillPersonLinesFill className="text-2xl" />
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
